/**
 * モーダルコンテンツ
 */

const actions = {
  /**
   * モーダル表示
   * @param obj args
   *   modalName: @/components/modal/contents/xxx.vueのコンポーネント名
   *   data: 表示する内容のデータ
   */
  showModal({ commit }, args) {
    commit('setModal', args);
  },

  /**
   * モーダル非表示
   */
  hideModal({ commit }, payload = null) {
    if (payload) {
      // 非表示時の独自処理がある場合はここに記述
      if (payload.type === 'update') commit('parentUpdate', payload);
    }
    commit('hideModal');
  },
};

const mutations = {
  setModal(state, args) {
    if (args.data) state.data = args.data;
    state.modalName = args.modalName;
    state.modalTitle = args.modalTitle;
    state.modalWidth = args.modalWidth;
  },

  hideModal(state) {
    state.modalName = '';
  },

  parentUpdate(state, args) {
    state.updateData = args;
  },
};

const state = {
  modalName: '',
  modalTitle: '',
  modalWidth: '',
  data: {},
  updateData: {},
};

export default {
  namespaced: true,
  actions,
  mutations,
  state,
};
